import React from 'react';
import { Handle, Position } from 'reactflow';
import TopHeaderPanel from '../TopHeaderPanel';

function EndNode({ id , data }) {
    const label = data?.label || 'End Node';
    return (
      <div className='node-style'>
        <div className='thpw'>{data.selectedNodeId === id && <TopHeaderPanel />}</div>
        
      <div className="node">
        <div className='node_head'>
        <span><i className='ri-close-line'></i></span>
          {label} <i className="mdi mdi-close" onClick={(e) => {
              e.stopPropagation();
              if (data?.onDelete) {
                data.onDelete(id);
              }
            }}></i>
            <p>this is end node</p>
            </div>
            
            {/* <div className='node_body'>
                <div>
                  <label>Text</label>
                  <input defaultValue={data?.text || ''} placeholder="Receiving input" disabled/>
                </div>
              </div> */}
            
            <Handle type="target" position={Position.Left} />
      </div>
      </div>
    )
}

export default EndNode